export enum ENUM {
    ADD='add',
    DELETE ="delete",
    EQUALS="==",
    AMEND="amend",
    CREATE="create",
    UPDATE="update",
    EXPCOURIER="expressCourier",
    HEADERPROFILE="headerProfile",
    PT06="PT06",
    PT53="PT53",
    INDPT="INDPT",
    ASCEND="ascend",
    DESCEND="descend",
    OK="ok",
    APPROVED="Approved",
    EXPORTER_CODE="exporterCode",
    CONSIGNEE_CODE="consigneeCode",
    IMPORTER_CODE="importerCode",
    PRODUCT_CODE="productCode",
    LOGICAL_OPERATOR="logicalOperator",
    OPERATOR="operator",
    ATTRIBUTE_NAME="attributeName",
    VALUE="value",
    DOUBLE="double",
    DRAFT="DRAFT",
    IS_EXPORTED="isExporter",
    GREEN= "green",
    ACTIVE ="active",
    ACTIVE_C="Active",
    INFORECORD="infoRecord",
    PFAPP="pfapp",
    PSREVIEW="psreview",
    ACCEPTED="ACCEPTED",
    REJECTED="Rejected",
    ONHOLD='On-Hold',
    DEFAULT='default',
    SUCCESS="success",
    ORANGE="orange",
    LIME="lime",
    ERROR="error",
    GOLD="gold",
    MAGENTA="magenta",
    DRAFT_S="Draft",
    INACTIVE="Inactive",
    COMPLETED="Completed",
    CLOSED="Closed",
    FA="FA",
    FAILED="Failed",
    INPROGRESS="In Progress",
    NODATA="No Data",
    BLUE="Blue",
    SUBMIT ='Submit',
    AMEND_S ='Amend',
    VIEW='View',
    CANCLE='Cancel',
    EDIT='edit',
    VIEW_S='view',
    CODE='code',
    PORTCODE="portcode",
    SEARCH="Search",
    SORT="Sort",
    DOWNLOAD='Download',
    UPLOAD='Upload',
    REVIEW='Review',
    DELETE_S='Delete',
  }
  export enum STATUS{
    CODE200 =200,
    CODE400=400,
    CODE500=500,
    CODE401=401
  }
  export const CommonConstants = {
    EMPTY_STRING : "",
    DP_NULL : null,
    DP_UNDEFINED : undefined,
    DP_DATE_FORMAT_1 : "YYYY-MMM-DD",
    DP_DATE_FORMAT_2 : "YYYY-MM-DD",
    DP_ONE : 1,
    DP_TEN : 10,
    DP_EMPTY_ARRAY : [],
    DP_ZERO:0,
    DP_LabelMaxLength:255,
    DP_ACS:"ACS",
    DP_NA:"NA",
    DP_SPAN:"12",
    countryFlagPath: '/assets/outline/countryFlag.svg#icon-'
  }